import { useCallback, useState } from 'react';

export const useClipboardCopy = (code: string) => {
  const [copyActive, setCopyActive] = useState(false);

  const handleCopyCode = useCallback(() => {
    if (!code) return;

    navigator.clipboard.writeText(code);
    if (!copyActive) {
      setCopyActive(true);
      setTimeout(() => {
        setCopyActive(false);
      }, 1000);
    }
  }, [code, copyActive, setCopyActive]);

  return { handleCopyCode, copyActive };
};
